import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfileService } from '../../../core/services/profile.service';

@Component({
  selector: 'vcp-create-application-popup',
  templateUrl: './create-application-popup.component.html',
  styleUrls: ['./create-application-popup.component.scss']
})
export class CreateApplicationPopupComponent implements OnInit {


  activeStep = 1;
  userData: any;
  userProfilePic: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private readonly dialogRef: MatDialogRef<CreateApplicationPopupComponent>,
   private ps:ProfileService) {
    this.ps.getUserById().subscribe((res)=>{
      if (res && res['code'] === 'success') {
        this.userData = res['data'];
      }
    });
   }


  ngOnInit(): void {}

  next() {
    if(this.activeStep==4){
      this.dialogRef.close();
      return;
    }
    this.activeStep++;
  }

}
